import { ReactElement } from 'react';
import PageHeader from '../../components/headers/PageHeader';
import UploadGoogleReviewScreen from '../../../../pages/UploadGoogleReviewScreen';
import { IonContent } from '@ionic/react';
import { useTranslation } from 'react-i18next';

const UploadGoogleReview = (): ReactElement => {
  const { t } = useTranslation(null, { keyPrefix: 'Modules:Mobile:Pages:UploadGoogleReview' });

  return (
    <>
      <PageHeader title={t('title')} />
      <IonContent className="min-h-[80dvh] space-y-sm">
        <UploadGoogleReviewScreen />
      </IonContent>
    </>
  );
};

export default UploadGoogleReview;
